<!-- desktop -->
<!--header starts-->
<div class="menu-bg mob-none">
  <div class="logo-container">
    <div class="logo clickable">
      <img alt="logoWhite" src="{{assetsUrl}}LogoWhite.png">
      <div class="logo-divider"></div>
    </div>
    <div class="subtext">Portal Manager</div>
  </div>
</div>
<div class="mob-block">
  <div class="menu-bg">
    <div class="logo-container">
        <div class="logo clickable">
            <img alt="logoWhite" src="{{assetsUrl}}LogoWhite.png">
            <div class="logo-divider"></div>
        </div>
        <div class="subtext">Portal Manager</div>
    </div>
</div>
</div>
<!--header ends-->

<div class="error-page">
  <span class="center">
    <p class="service-page-heading">Service Unavailable</p>
    <img src="{{ assetsUrl }}embarrassed.png" alt="embasrrassed-icon" />
    <p class="error-message">
      Please contact technical support for further assistance<br>
      <span class="boldText">Email: </span><a href="mailto:{{lnfServiceDeskemail}}">{{lnfServiceDeskemail}}</a><br>
      <span class="boldText">Phone:</span> 1-877-774-7747
    </p>
  </span>

</div>


<!--footer starts-->
<div class="fixed-footer">
  <app-footer [fullWidth]="true"></app-footer>
</div>
<!--footer ends-->